import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function Sunlit3D() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>Sunlit3D Dataset</BlockTitle>
          {/* <BlockSubtitle>Elemental Digital Environment</BlockSubtitle> */}
        </BlockContent>
        <BlockContent>
          <BlockText>The Sunlit3D dataset offers post-processed 3D reconstructions of buildings for shadow removal tasks. Existing 3D models with appropriate licenses were sourced from SketchFab, focusing on those with minimal shading. This was crucial, as each model was re-illuminated and the lighting baked into the texture map, providing data suitable for shadow removal. More details are provided in the section below.</BlockText>
        </BlockContent>
      </Block>



      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
            <ul>
                <li>70 models with minimal shading were sourced from the platform Sketchfab.</li>
                <li>Each model has a texture map which were resized to 8192x8192 px.</li>
                <li>Each model were postprocessed in Blender in order to generate texture maps consisting of (1) Normal information (2) Mask information, (3) Height information, (4) Shading information, (5) Reflectance information, (6) Illuminated Reflectance information</li>
                <li>Note that the original mesh is considered as the reflectance information</li>
                <li>The relfectance and shading components of each model are available in nine different illumination settings.</li>
            </ul>
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/s3d_dataset_new.webp'}/>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="1200px">
        <BlockContent>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/s3d_dataset_sun_new.webp'}/>
        </BlockContent>
        {/* <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
            <ul>
                <li>70 models with minimal shading were sourced from the platform Sketchfab.</li>
                <li>Each model has a texture map which were resized to 8192x8192 px.</li>
                <li>Each model were postprocessed in Blender in order to generate texture maps consisting of (1) Normal information (2) Mask information, (3) Height information, (4) Shading information, (5) Reflectance information, (6) Illuminated Reflectance information</li>
                <li>Note that the original mesh is considered as the reflectance information</li>
            </ul>
          </BlockText>
        </BlockContent> */}
      </Block>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
      <BlockContent textAlign="center" color="grey" fontStyle="italic">
        <BlockButton onClick={() => window.open('https://potechius.com/Sunlit3D')}>Visualizer</BlockButton>
        </BlockContent>
      <BlockContent textAlign="center" color="grey" fontStyle="italic">
        <BlockButton onClick={() => window.open('https://huggingface.co/datasets/hpotechius/Sunlit3D')}>Download</BlockButton>
        </BlockContent>
      </Block>


      <Footer/>
    </div>
  );
}

export default Sunlit3D;